import $ from 'jquery';

const SELECTOR = '.toggle-list';

function onDocumentReady() {
	$(SELECTOR).on('click', '.cta', onClickToggleList);
}

function onClickToggleList(e) {
	const clicked = $(e.currentTarget);
	const el = clicked.closest(SELECTOR);
	const extraItems = el.find('.extra-items');

	if (clicked.hasClass('active')) {
		clicked.removeClass('active').text('Read More +');
		extraItems.slideUp(true, false);

	} else {
		clicked.addClass('active').text('Read Less -');
		extraItems.slideDown(true, false);
	}
}

document.addEventListener('DOMContentLoaded', onDocumentReady);
